<template>
  <UtilTag class="flex items-center space-x-2 border auction-tag">
    <FontAwesomeIcon :icon="faGavel" />
    <span>Auction</span>
  </UtilTag>
</template>

<script>
import UtilTag from '@/components/utils/UtilTag'
import { faGavel } from '@fortawesome/pro-solid-svg-icons'

export default {
  name: 'UtilTagAuction',

  components: {
    UtilTag
  },

  data() {
    return {
      faGavel
    }
  }
}
</script>

<style lang="scss" scoped>
.tag.auction-tag {
  @apply font-medium;
  background: #ffd748;
  border: 1px solid #ddad04;
  color: #000;
}
</style>
